/** Aligns with `customerType` on parqco-fe fiscal profile (`company` | `natural_person`). */
export enum EFiscalBillingSection {
  COMPANY = 'company',
  NATURAL_PERSON = 'natural_person',
}
